import * as React from 'react';
import { styles } from './styles';
import { InlineDialog, InlineDialogProps } from '../../../InlineDialog';
import { DesignSection } from '@routes/event/create/DesignDemo/types';
import { DesignBucketContent } from './components/DesignBucketContent';
import { SelectionResetButton } from './components/SelectionResetButton';
import { DesignBucketLabel } from './components/DesignBucketLabel';

export type DesignBucketShellProps = {
  onTriggerClick: React.MouseEventHandler<HTMLDivElement>;
  onResetClick: React.MouseEventHandler<HTMLElement>;
};

interface Props {
  label: string;
  section: DesignSection;
  open: boolean;
  isMobile?: boolean;
  subtitle: string | JSX.Element;
  children: JSX.Element;
  onClose: InlineDialogProps<any>['onCloseRequest'];
}

export class DesignBucketShell extends React.Component<Props & DesignBucketShellProps> {
  static Content = DesignBucketContent;
  triggerRef = React.createRef<HTMLDivElement>();
  contentRef = React.createRef<HTMLDivElement>();

  handleTriggerClick: React.MouseEventHandler<HTMLDivElement> = e => {
    if (e.target instanceof Node && this.contentRef.current && this.contentRef.current.contains(e.target)) {
      return;
    }
    this.props.onTriggerClick(e);
  };

  getDropdownContent = () => {
    const content = (
      <div ref={this.contentRef}>
        {this.props.children}
        <div className={styles.resetContainer}>
          <SelectionResetButton section={this.props.section} onResetClick={this.props.onResetClick} />
        </div>
      </div>
    );
    if (this.props.isMobile) {
      if (this.props.open) {
        return content;
      } else {
        return null;
      }
    }
    return (
      <InlineDialog
        offset={24}
        onCloseRequest={this.props.onClose}
        contextData={null}
        isOpen={this.props.open}
        triggerRef={this.triggerRef.current}
        placement="bottom-start"
        refContainer={<div className={styles.valueContainer}>{this.props.subtitle || 'All'}</div>}
      >
        {content}
      </InlineDialog>
    );
  };
  render() {
    return (
      <div
        ref={this.triggerRef}
        onClick={this.handleTriggerClick}
        data-section={this.props.section}
        className={styles.filterOption}
      >
        <DesignBucketLabel
          isMobile={this.props.isMobile}
          subtitle={this.props.subtitle}
          collapsible={true}
          label={this.props.label}
          open={this.props.open}
        />
        <div>{this.getDropdownContent()}</div>
      </div>
    );
  }
}
